<template>
  <div>
    <div class="title">
      <h2 class="dp-inblock">{{ programName }} – 신청자 리스트</h2>
      <button
        class="admin-btn-default float-right ml-10"
        @click="openWindowPopup()"
      >
        + 수강자 등록
      </button>
      <button
        class="admin-btn-default float-right ml-10"
        @click="openModal('cancelList')"
        data-toggle="modal"
        data-target="#student_cancle"
      >
        수강신청 취소자
      </button>
      <button
        class="admin-btn-default float-right ml-10"
        @click="openModal('inregList')"
        data-toggle="modal"
        data-target="#student_cancle_list"
      >
        입과 불가자
      </button>
      <button
        class="admin-btn-default float-right"
        @click="openModal('inreg')"
        data-toggle="modal"
        data-target="#student_add"
      >
        + 입과 불가자 등록
      </button>
      <p class="w-100per">
        -신청자 / 대기자 리스트를 확인할 수 있습니다. <br />
        - <span class="txt-red">입과 불가자 등록</span> : 입과 불가자 등록을 할
        수 있습니다.<br />
        - <span class="txt-red">입과 불가자</span> : 입과 불가자 리스트 확인 및
        삭제를 할 수 있습니다.<br />
        - <span class="txt-red">수강신청 취소자</span> : 수강신청 취소자 복구 및
        엑셀 다운로드 할 수 있습니다.<br />
        - <span class="txt-red">수강자 등록</span> : 수강자 등록을 할 수
        있습니다.<br />
        - <span class="txt-red">일괄 상태 변경</span> : 일괄 상태 변경 및 SMS
        전송을 할 수 있습니다.
      </p>
    </div>

    <div class="w-100per mg-auto">
      <table class="admin-table-row table-auto">
        <thead>
          <tr>
            <th width="200px">이름</th>
            <td width="*">
              <input
                type="text"
                v-model="name"
                class="w-100per"
                placeholder="이름을 입력해 주세요"
              />
            </td>
            <th class="w-200px">E-mail</th>
            <td>
              <input
                type="text"
                v-model="email"
                class="w-100per"
                placeholder="E-mail을 입력해 주세요"
              />
            </td>
          </tr>
        </thead>
      </table>
      <div class="mt-10 float-right dp-block">
        <button class="admin-btn-default" @click="search()">검색</button>
      </div>
    </div>

    <div class="con w-100per mg-auto">
      <div class="state-box dp-inblock mt-50 w-100per">
        <button class="admin-btn-danger" @click="delApplicant()">
          삭제하기
        </button>
        <button class="admin-btn-default ml-10" @click="openModal('status')">
          일괄 상태 변경
        </button>
        <select
          name=""
          id=""
          v-model="status"
          @change="search()"
          class="w-150px h-40px ml-05 mr-05"
        >
          <option value="">대기상태 전체</option>
          <option value="Y">대기</option>
          <option value="N">신청 완료</option>
          <option value="C">신청 취소</option>
        </select>
        <select
          name=""
          id=""
          v-model="payStatus"
          @change="search()"
          class="w-130px h-40px mr-05"
        >
          <option value="">결제상태 전체</option>
          <option value="Y">결제완료</option>
          <option value="N">미결제</option>
          <option value="X">결제 없음</option>
          <option value="P">결제 취소 대기</option>
          <option value="C">결제 취소</option>
        </select>
        <button class="admin-btn-default float-right" @click="exportExcel()">
          엑셀 다운로드
        </button>
      </div>

      <div class="mt-20">
        <table class="admin-table-col mt-10 txt-center">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="allSelected"
                  @change="allSelect()"
                  name=""
                  id=""
                />
              </th>
              <th width="40px">No</th>
              <th width="130px">과정명</th>
              <th width="90px">과목</th>
              <th width="90px">이름</th>
              <th width="*">E-mail</th>
              <th width="80px">사번</th>
              <th width="70px">직급</th>
              <th width="100px">연락처</th>
              <th width="60px">상태</th>
              <th width="60px">결제금액</th>
              <th width="60px">결제방법</th>
              <th width="70px">결제여부</th>
              <th width="90px">신청일</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) of applyList" :key="index" :value="item">
              <td>
                <input
                  type="checkbox"
                  v-model="item.selected"
                  @change="watchSelected()"
                  name=""
                  id=""
                />
              </td>
              <td>{{ listLength - 50 * (pageNum - 1) - index }}</td>
              <td
                class="pointer txt-blue break-all"
                @click="
                  openModal(
                    'detail',
                    item.idx_itm_sugang_student_subject,
                    item.name,
                    item.idx_itm_sugang_student
                  )
                "
                data-toggle="modal"
                data-target="#student_selet"
              >
                {{ item.subject_name || "-" }} <br />
                <!-- 13:00~14:00 외 2건 -->
              </td>
              <td>{{ item.class_name }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.number || "-" }}</td>
              <td>{{ item.position || "-" }}</td>
              <td>{{ item.mobile || "-" }}</td>
              <td>{{ formatStatus(item.status) }}</td>
              <td>
                <span
                  v-if="item.price"
                  class="pointer txt-blue"
                  @click="detailPayment(item)"
                >
                  {{ numberFormat(item.price) }}
                </span>
                <span v-else> - </span>
              </td>
              <td>{{ formatPayWay(item.pay_way) }}</td>
              <td>{{ formatPayStatus(item.pay_status) }}</td>
              <td>{{ item.create_date.slice(0, 10) }}</td>
            </tr>
            <!-- 리스트에 내용이 없을 경우 -->
            <tr v-if="listLength === 0">
              <td colspan="13" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
            </tr>
          </tbody>
        </table>
        <button class="admin-btn-default mt-10" @click="moveListMain()">
          이전 페이지
        </button>
        <div class="paging mt-30">
          <ul>
            <li>
              <a class="pointer" @click="prevPaging()"> &lt; </a>
            </li>
            <li v-for="index in calcMaxPaging()" :key="index" class="txt-blue">
              <span class="pointer" style="padding: 8px">
                <a
                  @click="paging(index)"
                  :class="{ 'carrot-active bold': index === pageNum }"
                  >{{ index }}</a
                >
              </span>
            </li>
            <li>
              <a class="pointer" @click="nextPaging()"> &gt; </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <inreg-modal
      :parentIdx="pageIdx"
      v-if="isInregModalOpened"
      @close="closeModal()"
    ></inreg-modal>
    <inreglist-modal
      :parentIdx="pageIdx"
      v-if="isInregListModalOpened"
      @close="closeModal()"
    ></inreglist-modal>
    <cancel-list-modal
      v-if="isCancelListModalOpened"
      :parentIdx="pageIdx"
      @close="closeModal()"
    ></cancel-list-modal>
    <payment-modal
      v-if="isPaymentModalOpened"
      :parentPay="parentPay"
      @close="closeModal()"
    ></payment-modal>
    <!-- <h2>OOOO 과정 - 신청자 리스트</h2>
    <div>
        신청 받은 학습자 리스트를 확인하실 수 있습니다.
    </div>
    <div>
        <input type="text" v-model="searchText" placeholder="이름 또는 이메일 검색" />
        <button type="button">Search</button>
        <button type="button">수강자등록</button>
        <button type="button">입과불가자 리스트보기</button>
        <button type="button">입과불가자등록</button>
        <button type="button">수강신청취소자 리스트보기</button>
        <button type="button">엑셀다운로드</button>
    </div>
    <div>
        <ag-grid-vue style="height: 200px; width:100%; font-size: 12px" :animateRows="true" rowSelection="multiple" class="ag-theme-balham" :columnDefs="classListColumns" :rowData="classList" :gridOptions="gridOptions" @grid-ready="onGridReady" :frameworkComponents="frameworkComponents" :context="context" :defaultColDef="defaultColDef">
        </ag-grid-vue>
    </div>
    <div>
        <button type="button">삭제</button>
        <button type="button">일괄상태변경</button>
        <button type="button">수강취소</button>
    </div> -->
    <detail-modal
      v-if="isDetailModalOpened"
      :parentIdx="idxItmSugangSubject"
      :parentName="parentName"
      :idxItmSugangStudent="idxItmSugangStudent"
      @close="closeModal"
    ></detail-modal>
    <status-modal
      v-if="isStatusModalOpened"
      :parentAltYn="altYn"
      :parentData="parentData"
      @refresh="search()"
      @close="closeModal"
    ></status-modal>
  </div>
</template>

<script>
import DetailModal from "@/components/search/detailModal.vue";
import InregModal from "@/components/list/inregModal.vue";
import InreglistModal from "@/components/list/inregListModal.vue";
import CancelListModal from "@/components/list/cancelListModal.vue";
import StatusModal from "@/components/applyList/statusModal.vue";
import PaymentModal from "@/components/applyList/paymentModal.vue";
import FileSaver from "file-saver";
import { GetUrlParams } from "@/utils/common.js";
export default {
  components: {
    DetailModal,
    InregModal,
    InreglistModal,
    CancelListModal,
    StatusModal,
    PaymentModal,
  },

  data: () => ({
    applyList: [], // 신청자 리스트
    listLength: 0, // 신청자 인원수
    maxPagingCount: 1, // 최대 페이지 수
    maxPagePart: 1, // 최대 파트가 몇번째인지
    pagePart: 1, // 현재 페이징이 몇번째 파트에 있는지 (ex 1~10 1파트, 11~20 2파트)

    email: "", // 검색 - 이메일
    name: "", // 검색 - 이름
    pageIdx: "", // 수강 page인덱스 (페이징 넘버랑 다른개념, 수강 자체를 구분해줌)
    pageNum: 1, // 페이징 넘버
    pageSize: 50, //  페이징 사이즈 (default: 50)
    payStatus: "", // 결제전체 '', 결제완료 'Y',미결제: 'N',결제취소 'C',결제취소대기 'P'
    status: "", // 대기전체 '', 대기 Y, 신청완료 N, 신청취소 C
    altYn: "N",

    allSelected: false, // 전체 체크

    searchText: "",

    parentData: [],
    parentPay: {}, // 결제 상세 모달에 전달할 상세데이터

    isDetailModalOpened: false, // 신청내역 상세 모달 오픈 여부
    isInregModalOpened: false, // 입과 불가자 등록 모달 on/off
    isInregListModalOpened: false, // 입과 불가자 리스트 모달 on/off
    isCancelListModalOpened: false, // 수강신청 취소자 리스트 on/off
    isStatusModalOpened: false, // 상태 일괄변경 on/off
    isPaymentModalOpened: false, // 결제 상세보기 on/off

    classList: [], // 수강신청 클래스 리스트 데이터
    classListColumns: [], // 수강신청 클래스 리스트 컬럼

    programName: "",
    idxItmSugangSubject: "", // 수강신청 과목 idx
  }),

  mounted() {
    var oParams = GetUrlParams();
    if (typeof oParams.pageIdx === "undefined") {
      alert("해당 페이지는 주소창으로의 진입이 불가능합니다.");
      this.$router.push("/admin/list/main");
    }
    this.pageIdx = oParams.pageIdx;

    if (sessionStorage.getItem("programName")) {
      this.programName = sessionStorage.getItem("programName");
    }

    this.search();
  },

  methods: {
    detailPayment(data) {
      this.parentPay = data;
      this.isPaymentModalOpened = true;
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
      console.log(inputNumber, inputNumber);
    },

    // 리스트 체크박스 전체선택 / 전체해제
    allSelect() {
      for (var item of this.applyList) {
        item.selected = this.allSelected;
      }
    },

    // 체크박스 전체선택/전체해제시 테이블의 전체 체크박스 on/off 위함
    watchSelected() {
      var count = 0;
      for (var item of this.applyList) {
        if (item.selected === true) {
          count += 1;
        }
      }
      console.log("count", count);
      console.log("this.applyList.length", this.applyList.length);
      if (count === this.applyList.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },

    // 신청자 리스트 검색
    search() {
      var params = {
        email: this.email,
        name: this.name,
        pageIdx: this.pageIdx,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        payStatus: this.payStatus,
        status: this.status,
      };

      console.log("params", params);
      this.axios
        .get(
          this.axios.root +
            this.axios.port +
            `/admin/sugang-apply-list/${this.pageIdx}`,
          {
            params: params,
          }
        )
        .then((res) => {
          console.log("res", res);
          if (res.data.err === 0) {
            this.applyList = res.data.applyList;
            if (res.data.applyListSize) {
              this.listLength = res.data.applyListSize[0]["COUNT(*)"];
            } else {
              this.listLength = res.data.applyList.length;
            }
            this.altYn = res.data.altYn;
            this.maxPagingCount = Math.ceil(this.listLength / this.pageSize);
            this.maxPagePart = Math.ceil(this.maxPagingCount / 10);
            this.pagePart = Math.ceil(this.pageNum / 10);
          } else {
            // alert(res.data.result)
            this.applyList = [];
            this.listLength = 0;
          }
        });
    },

    // 페이징
    paging(page) {
      this.pageNum = page;
      this.search();
    },

    // 이전 페이징
    prevPaging() {
      if (this.pageNum === 1) {
        return false;
      } else {
        this.pageNum -= 1;
        this.search();
      }
    },

    // 다음 페이징
    nextPaging() {
      if (this.pageNum === this.maxPagingCount) {
        return false;
      } else {
        this.pageNum += 1;
        this.search();
      }
    },

    // 현재 페이지의 페이지 범위 계산
    calcMaxPaging() {
      if (this.maxPagingCount > this.pagePart * 10) {
        this.maxPagePart = this.pagePart * 10;
      } else {
        this.maxPagePart = this.maxPagingCount;
      }
      var pagingArray = [];
      for (var i = (this.pagePart - 1) * 10 + 1; i <= this.maxPagePart; i++) {
        pagingArray.push(i);
      }
      return pagingArray;
    },

    // 각 타입별 모달 열기
    openModal(type, idx, name, idxItmSugangStudent) {
      if (type === "inreg") {
        this.isInregModalOpened = true;
      } else if (type === "detail") {
        this.idxItmSugangSubject = idx;
        this.idxItmSugangStudent = idxItmSugangStudent;
        this.parentName = name;
        this.isDetailModalOpened = true;
      } else if (type === "inregList") {
        this.isInregListModalOpened = true;
      } else if (type === "cancelList") {
        this.isCancelListModalOpened = true;
      } else if (type === "status") {
        var count = 0;
        this.parentData = [];
        for (var item of this.applyList) {
          if (item.selected) {
            this.parentData.push(item.idx_itm_sugang_student_subject);
            count += 1;
            console.log("item.mobile", item.mobile);
            if (this.altYn === "Y") {
              if (item.mobile.trim() === "") {
                alert(
                  "연락처가 없는 신청자가 있습니다.\n연락처가 있는 신청자만 선택해주세요."
                );
                return false;
              }
            }
          }
        }

        if (count === 0) {
          alert("상태를 변경할 신청자를 선택해 주세요.");
          return false;
        } else {
          this.isStatusModalOpened = true;
        }
      }
    },

    // 각 타입별 모달 닫기
    closeModal() {
      if (this.isInregModalOpened) {
        this.isInregModalOpened = false;
      } else if (this.isInregListModalOpened) {
        this.isInregListModalOpened = false;
      } else if (this.isCancelListModalOpened) {
        this.isCancelListModalOpened = false;
      } else if (this.isStatusModalOpened) {
        this.parentData = [];
        this.isStatusModalOpened = false;
      } else if (this.isPaymentModalOpened) {
        this.isPaymentModalOpened = false;
      }
    },

    // 일괄 상태 변경
    batchSetStatus() {
      // var con_test = confirm("선택하신 리스트의 상태를 일괄변경하시겠습니까?");
      // if (con_test == true) {
      //     console.log('con_test', con_test)
      // } else {
      //     return false
      // }
    },

    // 신청자 삭제하기
    async delApplicant() {
      var count = 0;
      var removeApplys = [];
      for (var item of this.applyList) {
        if (item.selected === true) {
          removeApplys.push(item.idx_itm_sugang_student_subject);
          count += 1;
        }
      }

      if (count === 0) {
        alert("삭제할 신청자를 선택해주세요.");
        return false;
      }

      var con_test = confirm("선택하신 리스트를 삭제하시겠습니까?");
      if (con_test == true) {
        console.log("con_test", con_test);

        // var params = {
        //     userIdx: removeApplys.join('/')
        // }

        var params = new URLSearchParams();

        params.append("userIdx", removeApplys.join("/"));

        console.log("item", item);

        await this.axios
          .put(
            this.axios.root +
              this.axios.port +
              "/admin/sugang-apply-user-delete",
            params
          )
          .then((res) => {
            console.log("res", res);
            if (res.data.err === 0) {
              alert("삭제되었습니다.");
              this.search();
            } else {
              alert(res.data.result);
            }
          });
      } else {
        return false;
      }
    },

    // 수강자 등록 윈도우 팝업으로 열기
    openWindowPopup() {
      let routeData = this.$router.resolve({
        name: "list-applyList-list",
        query: {
          pageIdx: this.pageIdx,
        },
      });
      window.open(
        routeData.href,
        "window팝업",
        "width=750, height=450, top:50, left:50, menubar=no, status=no, toolbar=no"
      );
    },

    // status에 따른 한글 변환
    formatStatus(status) {
      switch (status) {
        case "Y":
          return "대기";
        case "N":
          return "신청완료";
        case "C":
          return "신청취소";
        case "F":
          return "신청실패";
        default:
          return "-";
      }
    },

    // payStatus에 따른 한글 변환
    formatPayStatus(status) {
      switch (status) {
        case "Y":
          return "결제완료";
        case "N":
          return "미결제";
        case "X":
          return "결제없음";
        case "C":
          return "결제취소";
        case "P":
          return "결제취소대기";
        default:
          return "-";
      }
    },

    // 결제방법에 따른 한글 변환
    formatPayWay(status) {
      switch (status) {
        case "C":
          return "카드";
        case "A":
          return "계좌이체";
        default:
          return "-";
      }
    },

    // 엑셀 다운로드 api 호출
    exportExcel() {
      // 리스트가 0개 미만일때는 다운로드 취소 처리
      if (this.listLength === 0) {
        alert("리스트가 0개인 경우에는 다운로드가 불가능합니다.");
        return false;
      }
      // var params = {
      //     email: this.email,
      //     name: this.name,
      //     pageIdx: this.pageIdx,
      //     payStatus: this.payStatus,
      //     status: this.status
      // }

      var params = new URLSearchParams();

      params.append("email", this.email);
      params.append("name", this.name);
      params.append("pageIdx", this.pageIdx);
      params.append("payStatus", this.payStatus);
      params.append("status", this.status);

      this.axios
        .post(
          this.axios.root +
            this.axios.port +
            `/excel/sugang-user-list/${this.pageIdx}`,
          params,
          {
            responseType: "arraybuffer",
          }
        )
        .then((res) => {
          console.log("res", res);
          FileSaver.saveAs(new Blob([res.data]), "sugang_user_list.xlsx");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    },

    // 이전 페이지(수강신청 관리)로 이동
    moveListMain() {
      this.$router.push("/admin/list/main");
    },
  },
};
</script>
